export default __webpack_public_path__ + "static/media/read-complete.044d3c70.svg";